import { useMemo } from "react"
import TimePicker from "react-time-picker"

import { convertTo24HourFormat } from "../../util/time"

import "react-time-picker/dist/TimePicker.css"

import "./timeInput.scss"
const TimeInputNew = ({
  value,
  setValue,
}: {
  value: string
  setValue: (value: string) => void
}) => {
  const handleChange = (newValue: any) => {
    setValue(newValue)
  }

  const time24hr = useMemo(() => convertTo24HourFormat(value), [value])

  return (
    <TimePicker
      onChange={handleChange}
      value={time24hr}
      format="h:mm a"
      amPmAriaLabel="Select AM/PM"
      clearIcon={null}
      disableClock={true}
      minutePlaceholder="MM"
      hourPlaceholder="HH"
      className="jooniverse__time-input"
      locale="en-US"
    />
  )
}

export default TimeInputNew
